<template>
  <el-row class="core_three_wrap">
    <el-col class="three_left">
      <div class="left_tit">
        {{ core.subTitle }}
      </div>
      <div class="left_desc">
        <div class="desc_item" v-for="item in core.children">
          <div class="item_left">
            <!-- <img src="@/assets/xiazai.png" alt=""> -->
          </div>
          <div class="item_right">
            <p>{{ item.title }}</p>
            <p>{{ item.subTitle }}</p>
          </div>
        </div>
      </div>
    </el-col>
    <el-col class="three_right">
      <img :src="core.image" alt="">
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    core: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.core_three_wrap {
  display: flex;
  justify-content: center;
  text-align: left;

  @media screen and (max-width: 768px) {
    margin-top: 25px;
    flex-wrap: wrap;
    padding: 0 10px;
    margin-bottom: 20px;
  }

  .three_left {
    width: 40%;
    padding: 20px 50px 20px 50px;

    @media screen and (max-width: 768px) {
      width: 100%;
      margin-bottom: 15px;
    }

    .left_tit {
      font-size: 23px;
      font-weight: bold;
      color: #3e3e3e;      

      @media screen and (max-width: 768px) {
        font-size: 1.4rem;
        margin-top: 10px;
        line-height: 1.4;
        padding: 0 5px;
      }
    }

    .left_desc {
      .desc_item {
        margin-top: 40px;
        display: flex;
        align-items: center;
        padding-left: 50px;

        .item_left {
          img {
            width: 50px;
            height: 50px;
          }
        }

        .item_right {
          margin-left: 20px;

          p {
            margin: 0;

            &:nth-child(1) {
              color: #717171;
              font-size: 16px;
              font-weight: bold;

              @media screen and (max-width: 768px) {
                font-size: 1rem;
                margin-top: 20PX;
              }
            }

            &:nth-child(2) {
              color: #717171;
              font-size: 14px;
              padding: 6px 0;

              @media screen and (max-width: 768px) {
                font-size: 0.8rem;
              }
            }
          }
        }
      }
    }
  }

  .three_right {
    width: 25%;
    height: 100%;

    @media screen and (max-width: 768px) {
      width: 90%;
      margin-top: 10px;
      display: flex;
      justify-content: center;
    }

    img {
      width: 100%;
      margin-top: 40px;

      @media screen and (max-width: 768px) {
        margin-top: 0;
        max-width: 320px;
        height: auto;
      }
    }
  }
}
</style>